/* Scroll functions */
(function( $ ) {
    'use strict'

    /* Check cookies on load */
    $( '.age-gate a.button' ).on( 'click', function() {
        /* Handle cookie allow click */
        if ( $ ( this ).hasClass( 'agegate-confirm' ) ) {
            /* Cookie accepted */
            setCookie( 'is_legal_age', true, 365 )

            /* Remove all active classes */
            $( '.age-gate a.button' ).removeClass( 'active' )
            $( this ).addClass( 'active' )
            
            /* Cookiegate was set - reload */
            window.location.href = oberbraeu.last_url
           
            /* Return */
            return false
        } else {
            /* Cookie accepted */
            deleteCookie( 'is_legal_age' )
        }
    })

    function setCookie(cname, cvalue, exdays) {
        var d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        var expires = 'expires='+d.toUTCString()
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }

    function deleteCookie(cname) {
        document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    }

    function getCookie(cname) {
        var name = cname + '=',
            ca = document.cookie.split(';')

        for(var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) == ' ') {
                c = c.substring(1)
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }
})( jQuery )
